export class Notification {
  message: string
  duration?: number
  class?: string
}
